/**
 * Environment-specific Configuration for E-Commerce Frontend (SDK Example)
 */

export type Environment = 'development' | 'staging' | 'production';

export interface EnvironmentConfig {
  name: Environment;
  api: {
    productsApi: string;
    brandsApi: string;
  };
  app: {
    url: string;
    name: string;
  };
  sdk: {
    enabled: boolean;
    version: string;
    url: string;
  };
}

const developmentConfig: EnvironmentConfig = {
  name: 'development',
  api: {
    productsApi: process.env.REACT_APP_PRODUCTS_API || 'https://api.fashcortex.com/api/v1',
    brandsApi: process.env.REACT_APP_BRANDS_API || 'https://api.fashcortex.com/api/v1',
  },
  app: {
    url: 'http://localhost:3001',
    name: 'E-Commerce Demo (Development)',
  },
  sdk: {
    enabled: true,
    version: '1.0.0',
    url: 'https://d2iyj97gfddxma.cloudfront.net/fashion-connect-sdk.js',
  },
};

const stagingConfig: EnvironmentConfig = {
  name: 'staging',
  api: {
    productsApi: process.env.REACT_APP_PRODUCTS_API || 'https://api.fashcortex.com/api/v1',
    brandsApi: process.env.REACT_APP_BRANDS_API || 'https://api.fashcortex.com/api/v1',
  },
  app: {
    url: 'https://d372c15rv7m7hu.cloudfront.net',
    name: 'E-Commerce Demo (Staging)',
  },
  sdk: {
    enabled: true,
    version: '1.0.0',
    url: 'https://stage-sdk.fashcortex.com/fashion-connect-sdk.js',
  },
};

const productionConfig: EnvironmentConfig = {
  name: 'production',
  api: {
    // Production: Always use api.fashcortex.com
    productsApi: process.env.REACT_APP_PRODUCTS_API || 'https://api.fashcortex.com/api/v1',
    brandsApi: process.env.REACT_APP_BRANDS_API || 'https://api.fashcortex.com/api/v1',
  },
  app: {
    url: 'https://d3q9im0et3seq4.cloudfront.net',
    name: 'E-Commerce Demo',
  },
  sdk: {
    enabled: true,
    version: '1.0.0',
    url: 'https://sdk.fashcortex.com/fashion-connect-sdk.js',
  },
};

/**
 * Get environment configuration based on REACT_APP_ENV or NODE_ENV
 */
export function getEnvironmentConfig(): EnvironmentConfig {
  const env = (process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development') as Environment;
  
  switch (env) {
    case 'staging':
      return stagingConfig;
    case 'production':
      return productionConfig;
    case 'development':
    default:
      return developmentConfig;
  }
}

export const environmentConfig = getEnvironmentConfig();

